import {Action, State, StateContext} from '@ngxs/store';
import {FallbackStateModel} from '@store/fallback/fallback-state.model';
import {Injectable} from '@angular/core';
import {UserService} from '@services/user/user.service';
import {
  GetFallbackData,
  SetBlackFallback,
  SetDefaultFallback,
  SetFallbackMediaToUpdate,
  UpdateFallback
} from '@store/fallback/fallback.actions';
import {Observable} from 'rxjs';
import {mergeMap, tap} from 'rxjs/operators';

@State<FallbackStateModel>({
  name: 'fallbackState',
  defaults: {
    fallbackMedia: null,
    fallbackMediaToUpdate: null,
    blackFallback: false
  }
})
@Injectable()

export class FallbackState {
  constructor(private userService: UserService) {
  }

  @Action(GetFallbackData)
  getFallbackData(ctx: StateContext<FallbackStateModel>): Observable<any> {
    return this.userService.getFallback()
      .pipe(
        tap((res) => {
          const state = ctx.getState();
          ctx.setState({
            ...state, blackFallback: res[0].status, fallbackMedia: res[1]
          });
        })
      );
  }

  @Action(SetFallbackMediaToUpdate)
  setFallbackMediaToUpdate(ctx: StateContext<FallbackStateModel>, {media}: SetFallbackMediaToUpdate): void {
    ctx.patchState({
      fallbackMediaToUpdate: media
    });
  }

  @Action(SetDefaultFallback)
  setDefaultFallback(ctx: StateContext<FallbackStateModel>): Observable<any> {
    return this.userService.setDefaultFallback()
      .pipe(
        mergeMap(() => ctx.dispatch(new SetBlackFallback(false))),
        tap(() => {
          ctx.patchState({fallbackMediaToUpdate: null, fallbackMedia: null, blackFallback: false});
        }),
      );
  }

  @Action(SetBlackFallback)
  setBlackFallback(ctx: StateContext<FallbackStateModel>, {value}: SetBlackFallback): Observable<any> {
    return this.userService.setBlackFallback(value)
      .pipe(
        tap((res) => {
          const state = ctx.getState();
          ctx.setState({
            ...state, blackFallback: value, fallbackMedia: res
          });
        })
      );
  }

  @Action(UpdateFallback)
  updateFallback(ctx: StateContext<FallbackStateModel>, {id}: UpdateFallback): Observable<any> {
    return this.userService.updateFallbackMedia(id)
      .pipe(
        tap((media) => {
          const state = ctx.getState();
          ctx.setState({
            ...state, blackFallback: false, fallbackMedia: media, fallbackMediaToUpdate: null
          });
        })
      );
  }
}
